import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './api';
import type {
  TrialSignupRequest,
  TrialSignupResponse,
  TrialVerifyResponse,
  TrialResendRequest,
  ActivationRequestResponse,
} from '@clareefai/types';

const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';

// Public endpoints use plain fetch (no auth token needed)
export const trialPublicApi = createApi({
  reducerPath: 'trialPublicApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    trialSignup: builder.mutation<TrialSignupResponse, TrialSignupRequest>({
      query: (body) => ({
        url: '/trial/signup',
        method: 'POST',
        body,
      }),
    }),

    verifyEmail: builder.mutation<TrialVerifyResponse, { token: string }>({
      query: ({ token }) => ({
        url: '/trial/verify-email',
        method: 'POST',
        body: { token },
      }),
    }),

    resendVerification: builder.mutation<{ message: string }, TrialResendRequest>({
      query: (body) => ({
        url: '/trial/resend-verification',
        method: 'POST',
        body,
      }),
    }),
  }),
});

// Authenticated trial endpoints (VENDOR role)
export const trialApi = createApi({
  reducerPath: 'trialApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    requestActivation: builder.mutation<ActivationRequestResponse, void>({
      query: () => ({
        url: '/trial/activation-request',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useTrialSignupMutation,
  useVerifyEmailMutation,
  useResendVerificationMutation,
} = trialPublicApi;

export const { useRequestActivationMutation } = trialApi;
